import { Avatar as MuiAvatar, Skeleton } from '@mui/material';
import { getInitials } from '@utils/name';
import { AvatarProps } from './Avatar.props';

// Size mappings for skeleton
const sizeMap: Record<string, number> = {
  s: 24,
  m: 40,
  l: 56,
  xl: 80,
};

export const Avatar = ({
  name,
  children,
  size = 'm',
  isLoading = false,
  sx,
  ...props
}: AvatarProps) => {
  // Show skeleton when loading
  if (isLoading) {
    const pixelSize = sizeMap[size] || 40;
    return (
      <Skeleton
        variant="circular"
        width={pixelSize}
        height={pixelSize}
        animation="wave"
        sx={sx}
      />
    );
  }

  return (
    <MuiAvatar {...props} sx={sx} className={`avatar-size-${size}`}>
      {children || (name ? getInitials(name) : undefined)}
    </MuiAvatar>
  );
};

export default Avatar;
